import { Color } from 'three';
import { DEVICE_SIZE } from 'modules/editor/constants';
import shadowFragment from 'modules/editor/shaders/shadow.frag';
import shadowVertex from 'modules/editor/shaders/shadow.vert';

const size = DEVICE_SIZE * 1.2;
const uniforms = {
  uColor: { value: new Color(0xbfbfbf) },
  uMin: { value: 1 - (size - DEVICE_SIZE) / (size / 2) },
};

export const DeviceShadow = () => {
  return (
    <mesh>
      <shaderMaterial vertexShader={shadowVertex} fragmentShader={shadowFragment} uniforms={uniforms} transparent />
      <circleGeometry args={[size, 72]} />
    </mesh>
  );
};
